import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  materializedSegments = 'materializedSegments',
  materializedSegment = 'materializedSegment',
  materializedSegmentLoadJob = 'materializedSegmentLoadJob',
}

// Internal (implementation) route refs for this plugin's own routing
export const materializedSegmentsRouteImplRef = createRouteRef({
  id: RoutesIds.materializedSegments,
});
export const rootRouteRef = materializedSegmentsRouteImplRef;
export const materializedSegmentRouteImplRef = createSubRouteRef({
  id: RoutesIds.materializedSegment,
  parent: rootRouteRef,
  path: '/:id',
});
export const materializedSegmentLoadJobRouteImplRef = createSubRouteRef({
  id: RoutesIds.materializedSegmentLoadJob,
  parent: rootRouteRef,
  path: '/:id/load-job-create',
});

// External route refs for other plugins/apps to bind
export const materializedSegmentsRouteRef = createExternalRouteRef({
  id: RoutesIds.materializedSegments,
});
export const materializedSegmentRouteRef = createExternalRouteRef({
  id: RoutesIds.materializedSegment,
  params: ['id'],
});
export const materializedSegmentLoadJobRouteRef = createExternalRouteRef({
  id: RoutesIds.materializedSegmentLoadJob,
  params: ['id'],
});

export const Routes = {
  materializedSegments: materializedSegmentsRouteImplRef,
  materializedSegment: materializedSegmentRouteImplRef,
  materializedSegmentLoadJob: materializedSegmentLoadJobRouteImplRef,
} satisfies Record<RoutesIds, RouteRef | SubRouteRef>;

export const ExternalRoutes = {
  materializedSegments: materializedSegmentsRouteRef,
  materializedSegment: materializedSegmentRouteRef,
  materializedSegmentLoadJob: materializedSegmentLoadJobRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef>;
